
export enum ERRORS {
  FIXTURE_NO_DATA = "No fixture data available.",
  FIXTURE_NO_LIVE_DATA = "No live data available.",
  FIXTURE_NO_MAP = "No map stats yet, this match is currently getting verified.",
  FIXTURE_NO_MAP_FALLBACK = "No map stats yet. Displaying live data.",
  LIVE_FIXTURE_CLUTCHES_DISABLED = "Clutches are unavailable.",
  LIVE_FIXTURE_ANALYZER_ERROR = "",
  LIVE_FIXTURE_UNEXPECTED_ERROR = "",
  LIVE_FIXTURE_EXCESSIVE_DEATHS = "Excessive amount of deaths registered in a round.",
  JOIN_ERROR_PLAYER = "Mismatch between fixture and analyzed data (Players).",
  JOIN_ERROR_STATS = "Mismatch between fixture and analyzed data (Match stats).",
  WEBSOCKET_401 = "Received HTTP code 401 from the websocket.", 
  WEBSOCKET_ENDED = `LiveAPI sent {"type:": "ended"}`, 
  HISTORIC_LIVE_FIXTURE_EMPTY_DATA = "Received empty historic live data",
  VERIFICATION_BACKOFF = "Waiting for post-match data"
}

//TODO cannot instanceof for some reason?
export class JoiningError extends Error {
  constructor(message) {
    super(message);
    this.name = "Joining error";
  }
}


export class AnalyzerError extends Error {
  constructor(message) {
    super(message);
    this.name = ERRORS.LIVE_FIXTURE_ANALYZER_ERROR;
    // this.name = ERRORS[ERRORS.LIVE_FIXTURE_ANALYZER_ERROR]; // TODO this doesn't work?
  }
}

export class UnexpectedError extends AnalyzerError {
  constructor(message) {
    super(message);
    this.name = "LIVE_FIXTURE_UNEXPECTED_ERROR";
  }
}

export class GameStateError extends AnalyzerError {
  constructor(message) {
    super(message);
    this.name = "LIVE_FIXTURE_EXCESSIVE_DEATHS";
  }
}